const nextGeneration = (ref) => {
  if (!ref) return null;
  const next = Number(ref.current || 0) + 1;
  ref.current = next;
  return next;
};

export function invalidateSportsnewDetailRequest({
  abortControllerRef,
  latestRequestRef,
  requestSeqRef,
  chunkRafRef,
  cancelFrame,
  recoveryGenerationRef,
}) {
  abortControllerRef?.current?.abort?.();
  if (abortControllerRef) abortControllerRef.current = null;
  if (latestRequestRef) latestRequestRef.current = null;
  nextGeneration(requestSeqRef);
  invalidateSportsnewDetailRecovery(recoveryGenerationRef);

  if (chunkRafRef?.current != null && typeof cancelFrame === 'function') {
    cancelFrame(chunkRafRef.current);
  }
  if (chunkRafRef) chunkRafRef.current = null;
}

export function beginSportsnewDetailRequest({ latestRequestRef, requestSeqRef, fixtureId }) {
  if (fixtureId == null) return null;
  latestRequestRef.current = fixtureId;
  return {
    fixtureId: String(fixtureId),
    requestSeq: Number(requestSeqRef?.current || 0),
  };
}

export function isSportsnewDetailRequestCurrent({
  token,
  latestRequestRef,
  requestSeqRef,
}) {
  if (!token) return false;
  return String(latestRequestRef?.current ?? '') === token.fixtureId
    && Number(requestSeqRef?.current || 0) === Number(token.requestSeq);
}

export function invalidateSportsnewDetailRecovery(recoveryGenerationRef) {
  return nextGeneration(recoveryGenerationRef);
}

export function beginSportsnewDetailRecovery(recoveryGenerationRef, fixtureId) {
  const normalizedFixtureId = fixtureId == null ? null : String(fixtureId);
  if (!normalizedFixtureId) return null;
  return {
    fixtureId: normalizedFixtureId,
    generation: invalidateSportsnewDetailRecovery(recoveryGenerationRef),
  };
}

export function isSportsnewDetailRecoveryCurrent({
  token,
  recoveryGenerationRef,
  detailFixtureIdRef,
  operatorSuspendedFixtureIdsRef,
}) {
  if (!token || token.generation == null) return false;
  if (Number(recoveryGenerationRef?.current) !== Number(token.generation)) return false;
  if (String(detailFixtureIdRef?.current ?? '') !== token.fixtureId) return false;
  return !operatorSuspendedFixtureIdsRef?.current?.has?.(token.fixtureId);
}

export function shouldClearSportsnewActiveDetail(detailFixtureId, fixtureIds) {
  if (detailFixtureId == null || !Array.isArray(fixtureIds)) return false;
  const activeFixtureId = String(detailFixtureId);
  return fixtureIds.some((fixtureId) => String(fixtureId) === activeFixtureId);
}

export function isSportsnewDetailUnavailable(value) {
  const directStatus = (
    typeof value?.status === 'number'
    || (typeof value?.status === 'string' && /^\d+$/.test(value.status))
  ) ? value.status : undefined;
  const status = Number(
    value?.httpStatus
    ?? value?.statusCode
    ?? value?.response?.status
    ?? directStatus,
  );
  return status === 404 || status === 410;
}
